import { render, staticRenderFns } from "./_base-nav-search.vue?vue&type=template&id=8051d3b2"
import script from "./_base-nav-search.vue?vue&type=script&lang=js"
export * from "./_base-nav-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports